import i18n from 'src/i18n';
import Tables from 'src/class/Tables';
import EvolutionaryStage from 'src/views/Pages/Dashboard/Sigatoka/BiologicalWarningReport/components/EvolutionaryStage.vue';

const configTable = () => {
  const Table = { ...Tables.Table };
  Table.tableColumns = [
    {
      prop: 'farm.zone.name',
      label: i18n.t('common_words.zone'),
      minWidth: 120,
      sortable: true,
      align: 'center',
    },
    {
      prop: 'farm.subzone.name',
      label: i18n.t('common_words.subzone'),
      minWidth: 120,
      sortable: true,
      align: 'center',
    },
    {
      prop: 'farm.name',
      label: i18n.t('common_words.farm'),
      minWidth: 120,
      sortable: true,
      align: 'center',
    },
    {
      prop: 'lot.name',
      label: i18n.t('common_words.allotment'),
      minWidth: 110,
      sortable: true,
      align: 'center',
    },
    {
      prop: 'date',
      label: i18n.t('common_words.date'),
      minWidth: 100,
      sortable: true,
      align: 'center',
    },
    {
      prop: 'total_last_week',
      label: i18n.t('sigatoka.total_last_week'),
      minWidth: 80,
      sortable: true,
      align: 'center',
    },
    {
      prop: 'total_actual_week',
      label: i18n.t('sigatoka.total_actual_week'),
      minWidth: 80,
      sortable: true,
      align: 'center',
    },
    {
      prop: 'ref',
      label: i18n.t('sigatoka.ref'),
      minWidth: 80,
      sortable: true,
      align: 'center',
    },
    {
      prop: 'reh1',
      label: i18n.t('sigatoka.reh') + '1',
      minWidth: 80,
      sortable: true,
      align: 'center',
    },
    {
      prop: 'reh',
      label: i18n.t('sigatoka.reh'),
      minWidth: 80,
      sortable: true,
      align: 'center',
    },
    {
      prop: 'rem',
      label: i18n.t('sigatoka.rem'),
      minWidth: 80,
      sortable: true,
      align: 'center',
    },
    {
      prop: 'gross_sum',
      label: i18n.t('sigatoka.gross_sum'),
      minWidth: 80,
      sortable: true,
      align: 'center',
    },
    {
      prop: 'evolutionary_stage',
      label: i18n.t('sigatoka.evolutionary_status'),
      minWidth: 80,
      sortable: true,
      align: 'center',
      formatter: EvolutionaryStage,
    },
  ];

  return { Table };
};

export default configTable;
